export const LogoWorkFull: {
  name: 'logo_work_full-5697ec9ffe6b'
} = {
  name: 'logo_work_full-5697ec9ffe6b'
}
